<template>
  <span class="frisbuy-summary-widget__content">
    {{ props.text }}
  </span>
</template>

<script lang="ts" setup>
const props = defineProps<{ text: string }>();
</script>
